import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Container,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core";
import Button from "../../shared/components/Button";
import Typography from "../../shared/components/Typography";
import { Link as RouterLink } from "react-router-dom";
import { AppLinkHrefs } from "../../navigation/navigationHelpers";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      backgroundColor: theme.palette.secondary.light,
      overflow: "hidden",
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(10),
    },
    container: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    item: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(0, 5),
    },
    title: {
      marginBottom: theme.spacing(8),
    },
    image: {
      height: 55,
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
    button: {
      marginTop: theme.spacing(8),
    },
  });

function ProductInfo(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography
          align="center"
          variant="h4"
          marked="center"
          className={classes.title}
          component="h2"
        >
          Everything you need
        </Typography>
        <div>
          <Grid container spacing={5}>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img src="/smart.png" alt="smart" className={classes.image} />
                <Typography variant="h5" align="center">
                  Start off on the right foot with smart technology choices.
                  Take advantage of the best tools the web has to offer while
                  being guided around pain points and frustrating blockers.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img src="/quick.png" alt="fast" className={classes.image} />
                <Typography variant="h5" align="center">
                  Get your web app up and running fast without compromising your
                  ability to scale or making decisions you'll regret later.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.item}>
                <img
                  src="/source.png"
                  alt="source code"
                  className={classes.image}
                />
                <Typography variant="h5" align="center">
                  Written by a developer, for developers. Full source code
                  (including the source code for this site!) and in-depth
                  explanations from a former Facebook engineer.
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <Button
          color="secondary"
          size="large"
          variant="contained"
          className={classes.button}
          component={RouterLink}
          to={AppLinkHrefs.Introduction}
        >
          Start Building
        </Button>
      </Container>
    </section>
  );
}

export default withStyles(styles)(ProductInfo);
